import { Link } from 'react-router-dom';
import { StatGroup, StatStrip } from './StatGroup';
import type { CockpitCustomerHealth } from '../../types';

function dollars(cents: string | null): string {
  if (cents === null) return '—';
  const n = Number(cents) / 100;
  return n.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
}

export function CustomerHealth({ data }: { data: CockpitCustomerHealth }) {
  return (
    <div className="space-y-4">
      <StatStrip cols={3}>
        <StatGroup label="Active customers" hero={data.counts.ACTIVE} caption="fundraiser this school year" />
        <StatGroup
          label="Slipping"
          hero={<span className={data.counts.SLIPPING > 0 ? 'text-amber-600 dark:text-amber-400' : ''}>{data.counts.SLIPPING}</span>}
          caption="only prior-year fundraiser"
        />
        <StatGroup label="Lifetime raised" hero={dollars(data.lifetimeRaisedCents)} caption="all fundraisers" />
      </StatStrip>

      <div className="card p-4 sm:p-6">
        <h3 className="text-sm font-semibold text-gray-900 dark:text-gray-100 mb-3">Slipping customers</h3>
        {data.slippingList.length === 0 ? (
          <p className="text-sm text-gray-400 dark:text-gray-500">No slipping customers — nice.</p>
        ) : (
          <ul className="space-y-2">
            {data.slippingList.map((o) => (
              <li key={o.organizationId}>
                <Link to={`/organizations/${o.organizationId}`} className="flex items-center justify-between gap-2 rounded-lg p-2 hover:bg-gray-50 dark:hover:bg-gray-700/40 transition-colors">
                  <span className="min-w-0 truncate font-medium text-gray-900 dark:text-gray-100">{o.name}</span>
                  <span className="text-xs text-gray-500 dark:text-gray-400 whitespace-nowrap">{o.owner ?? 'Unassigned'} · {dollars(o.lastFundraiserAmountCents)}</span>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
